export default __webpack_public_path__ + "static/media/p-sm-3.da114d97.png";